import { OrderStatus } from "../enums";

const DELETABLE_STATUSES = [
  OrderStatus.NEW,
  OrderStatus.ACK,
  OrderStatus.ALLOCATED,
  OrderStatus.CANCELLED,
];

const DELETABLE_SUPPLIER_STATUSES = [
  OrderStatus.NEW,
  OrderStatus.ACK,
  OrderStatus.IN_REVIEW,
  OrderStatus.REVOKED,
];

export function getDeleteOrderDisabled(
  orderStatus: string | undefined,
  orderType: string | undefined,
  userRole: string | undefined,
  isDeleted: boolean | undefined,
  activeSupplierStatus?: string | undefined,
): boolean {
  // Already deleted
  if (isDeleted) {
    return true;
  }

  // Role check
  if (userRole !== "EXECUTIVE" && userRole !== "HEAD_OF_OPERATIONS") {
    return true;
  }

  // Order type check
  if (orderType !== "REGULAR") {
    return true;
  }

  // Status check
  if (
    !orderStatus ||
    !DELETABLE_STATUSES.includes(orderStatus as OrderStatus)
  ) {
    return true;
  }

  // Supplier status check (only if active supplier exists)
  if (
    activeSupplierStatus &&
    !DELETABLE_SUPPLIER_STATUSES.includes(activeSupplierStatus as OrderStatus)
  ) {
    return true;
  }

  return false;
}

export function getDeleteOrderTooltip(
  orderStatus: string | undefined,
  orderType: string | undefined,
  userRole: string | undefined,
  isDeleted: boolean | undefined,
  activeSupplierStatus?: string | undefined,
): string {
  // Already voided
  if (isDeleted) {
    return "Order is already voided";
  }

  // Role check
  if (userRole !== "EXECUTIVE" && userRole !== "HEAD_OF_OPERATIONS") {
    return "Only HOO and Executive can void orders";
  }

  // Order type check
  if (orderType !== "REGULAR") {
    return "Only REGULAR orders can be voided";
  }

  // Status check
  if (
    !orderStatus ||
    !DELETABLE_STATUSES.includes(orderStatus as OrderStatus)
  ) {
    return "Order status must be NEW, ACK, ALLOCATED, or CANCELLED";
  }

  // Supplier status check (only if active supplier exists)
  if (
    activeSupplierStatus &&
    !DELETABLE_SUPPLIER_STATUSES.includes(activeSupplierStatus as OrderStatus)
  ) {
    return "Active supplier status must be NEW, ACK, IN-REVIEW, or REVOKED";
  }

  return "Void Order";
}
